<template>
  <a-card size="small" class="customer-filter" title="筛选条件" :bordered="false">
    <a-form-model class="search-form">
      <a-form-model-item :label-col="labelCol" class="search-form" label-align="left">
        <a-row>
          <a-col :span="6">
            <span style="margin-right: 8px">创建时间:</span>
            <a-range-picker v-model="checkedDate" :default-value="checkedDate" :allow-clear="false" :ranges="ranges" />
          </a-col>
          <!-- <a-col :span="6">
            <span style="margin-right: 8px">标记:</span>
            <span v-has="{ code: 'ticket:tag:show' }">
              <a-select v-model="refers" allow-clear style="width: 80%" placeholder="工单标记">
                <a-select-option v-for="(item, index) in ticketUserTag" :key="index" :value="item.value">
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </span>
          </a-col> -->
        </a-row>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
import moment from 'moment';
import { teamList } from '@/api/system/team';
import { ticketUserTag } from '@/utils/dictionary';
export default {
  name: 'DataFilter',
  data() {
    return {
      checkedDate: [moment().subtract(2, 'week').add(1, 'day'), moment()],
      labelCol: { span: 1 },
      refers: '',
      ticketUserTag,
      wrapperCol: {},
      checkAll: true,
      indeterminate: false,
      plainOptions: [],
      teams: [],
      selectedTeams: [],
      ranges: {
        近一周: [moment().subtract('days', 7), moment()],
        近两周: [moment().subtract('days', 14), moment()],
        近一个月: [moment().subtract('days', 30), moment()],
        近三个月: [moment().subtract('days', 90), moment()],
        当月: [moment().startOf('month'), moment()],
        当季: [moment().startOf('quarter'), moment()],
        当年: [moment().startOf('year'), moment()]
      }
    };
  },

  computed: {
    filter() {
      const { checkedDate, refers } = this;
      return {
        checkedDate,
        refers
      };
    }
  },

  watch: {
    filter() {
      this.$emit('change', this.checkedDate, this.refers);
    }
  },
  created() {
    // this.getTeamList();
    this.$emit('change', this.checkedDate, this.refers);
  },

  methods: {
    // handleChange(team_id, checked) {
    //   const { selectedTeams } = this;
    //   const nextSelectedTeams = checked ? [...selectedTeams, team_id] : selectedTeams.filter(t => t !== team_id);
    //   this.selectedTeams = nextSelectedTeams;
    // },
    // // 获取团队列表
    // getTeamList() {
    //   teamList({ category: 1 }).then(res => {
    //     this.teams = res.data.items;
    //   });
    // }
  }
};
</script>

<style lang="less" scoped>
/deep/ .customer-filter {
  .ant-page-header {
    padding: 0;
  }
  margin-bottom: 16px;
  .ant-form-item {
    margin-bottom: 8px;
    display: flex;
    .ant-form-item-control-wrapper {
      flex: 1;
    }
  }
  .filter-right {
    float: right;
    text-align: right;
  }
}
.customer-col {
  margin-top: 16px;
}
</style>
